import { graphql } from "react-relay";
import { AvatarPerson } from "@components/avatar";

export const eventPeopleFragments = {
  org: graphql`
    fragment EventPeople_org on Org
    @argumentDefinitions(
      externalEventId: { type: "String!" }
      eventCalendarId: { type: "String!" }
      timeZone: { type: "String!" }
      personCalendarIds: { type: "[String]!", defaultValue: [] }
    ) {
      ...AvatarPerson_org
      id
      experiments

      computeCurrentSlotImpactErrorable(externalEventId: $externalEventId) {
        __typename

        ... on GraphEntityError {
          statusCode
          message
        }

        ... on CurrentScheduledSlotImpact {
          currentSlot {
            summary {
              conflictingAttendees
              unavailableAttendees
              inconvenientForAttendees
              focusTimeMinutesCost
            }
            attendanceImpacts {
              hasConflict
              calendarId
              focusTimeMinutesCost
              inconveniences
              unavailabilities
              conflictingMeetings
            }
          }
          uncrawledCalendars
        }
      }
    }
  `,
  event: graphql`
    fragment EventPeople_event on Event {
      organizer {
        urnValue
      }
      attendees {
        organizer
        urnValue
        responseStatus
      }
      attendeePeople {
        __typename
        ... on PersonList {
          list {
            ...AvatarPerson_person
            id
            emails
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
          }
        }
      }
    }
  `,
};
